import {Fragment, useEffect, useState} from "react";
import {Divider, Grid, MenuItem, Paper, TextField, Typography} from "@mui/material";
import {promiseServer} from "../../Global/FunctionToConnection";

const KEYS_VALUES={
    P1: "P1",
    m1: "m1",
    presion_1:"presion_1",
    P2: "P2",
    m2: "m2",
    presion_2:"presion_2",
    P3: "P3",
    m3: "m3",
    presion_3:"presion_3",
    P4: "P4",
    m4: "m4",
    presion_4:"presion_4",
    P5: "P5",
    m5: "m5",
    presion_5:"presion_5",
    P6: "P6",
    m6: "m6",
    presion_6:"presion_6",
}

export const POSITION = "position";

const M_VALUES = [
    {value: 18, label: "18"},
    {value: 17.5, label: "17.5"},
    {value: 17, label: "17"},
    {value: 16.5, label: "16.5"},
    {value: 16, label: "16"},
    {value: 15.5, label:"15.5"},
    {value: 15, label: "15"},
    {value: 14.5, label:"14.5"},
    {value: 14, label: "14"},
    {value: 13.5, label:"13.5"},
    {value: 13, label: "13"},
    {value: 12.5, label:"12.5"},
    {value: 12, label: "12"},
    {value: 11.5, label:"11.5"},
    {value: 11, label: "11"},
    {value: 10.5, label:"10.5"},
    {value: 10, label: "10"},
    {value: 9.5, label:"9.5"},
    {value: 9, label: "9"},
    {value: 8.5, label:"8.5"},
    {value: 8, label: "8"},
    {value: 7.5, label:"7.5"},
    {value: 7, label: "7"},
    {value: 6.5, label:"6.5"},
    {value: 6, label: "6"},
    {value: 5.5, label:"5.5"},
    {value: 5, label: "5"},
    {value: 4.5, label:"4.5"},
    {value: 4, label: "4"},
    {value: 3.5, label:"3.5"},
    {value: 3, label: "3"},
    {value: 2.5, label:"2.5"},
    {value: 2, label: "2"},
    {value: 1.5, label: "1.5"},
    {value: 1, label: "1"},
]

export function CheckTireComponent({titleTab="", report=null , setReport = null, isBus= true}){


    const [marcaOptions, setMarcaOptions] = useState([]);

    useEffect(() => {
        const getMarca = async () => {
            try {
                let responseMarca = await promiseServer("marca_llantas");

                setMarcaOptions(()=>responseMarca.marca);

            } catch (e) {
                console.error(e)
            }
        }
        getMarca();
    }, []);

    const handlingValueTire = (keyValue) => (dataSelected) =>{
        setReport((oldValues)=>{
            return {
                ...oldValues,
                [keyValue]: keyValue[0] === "m" || keyValue[0] === "p"? dataSelected.target.value: marcaOptions.find(item => item.id === dataSelected.target.value )
            }
        })
    }

    function handlingText(text){
        return text.id? text.id:"";
    }

    return(
        <Paper elevation={12} style={{padding: "4vh"}}>

            <Grid item xs={12} container direction="row" justifyContent="center" alignItems="center">

                <Typography>
                     {`Revision ${titleTab}`}
                </Typography>

            </Grid>

            <Divider/>

            <Grid container mt={1} spacing={2}>

                <Grid item xs={4}>
                    <TextField id={`${POSITION}-P1`} fullWidth onChange={handlingValueTire("P1")} select label="Pocision P1" variant="filled" defaultValue={handlingText(report[KEYS_VALUES.P1]) } value={report[KEYS_VALUES.P1].id}>
                        {
                            marcaOptions.map((marca, index)=>(
                                <MenuItem key={`option-${index}`} value={marca.id}>
                                    <Typography>{marca.label}</Typography>
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={4}>
                    <TextField id={`${POSITION}-m1`} onChange={handlingValueTire("m1")} fullWidth select label="Milimetros P1" variant="filled" defaultValue={report[KEYS_VALUES.m1]} value={report[KEYS_VALUES.m1]} >
                        {
                            M_VALUES.map((things, index)=>(
                                <MenuItem key={`option-${index}`} value={things.value}>
                                    <Typography>{things.label}</Typography>
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        type="number"
                        label="Presión en la llanta 1"
                        variant="filled"
                        fullWidth
                        value={report[KEYS_VALUES.presion_1]}
                        onChange={handlingValueTire("presion_1")}
                        InputProps={{ inputProps: { min: 1 } }}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField id={`${POSITION}-P2`} fullWidth onChange={handlingValueTire("P2")} select label="Pocision P2" variant="filled" defaultValue={handlingText(report[KEYS_VALUES.P2])} value={report[KEYS_VALUES.P2].id}>
                        {
                            marcaOptions.map((marca, index)=>(
                                <MenuItem key={`option-${index}`} value={marca.id}>
                                    <Typography>{marca.label}</Typography>
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={4}>
                    <TextField id={`${POSITION}-m2`} onChange={handlingValueTire("m2")} fullWidth select label="Milimetros P2" variant="filled" defaultValue={report[KEYS_VALUES.m2]} value={report[KEYS_VALUES.m2]} >
                        {
                            M_VALUES.map((things, index)=>(
                                <MenuItem key={`option-${index}`} value={things.value}>
                                    <Typography>{things.label}</Typography>
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={4}>
                    <TextField
                      type="number"
                      label="Presión en la llanta 2"
                      variant="filled"
                      fullWidth
                      InputProps={{ inputProps: { min: 1 } }}
                      value={report[KEYS_VALUES.presion_2]}
                      onChange={handlingValueTire("presion_2")}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField id={`${POSITION}-P3`} fullWidth onChange={handlingValueTire("P3")} select label="Pocision P3" variant="filled" defaultValue={handlingText(report[KEYS_VALUES.P3])} value={report[KEYS_VALUES.P3].id}>
                        {
                            marcaOptions.map((marca, index)=>(
                                <MenuItem key={`option-${index}`} value={marca.id}>
                                    <Typography>{marca.label}</Typography>
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={4}>
                    <TextField id={`${POSITION}-m3`} onChange={handlingValueTire("m3")} fullWidth select label="Milimetros P3" variant="filled" defaultValue={report[KEYS_VALUES.m3]} value={report[KEYS_VALUES.m3]} >
                        {
                            M_VALUES.map((things, index)=>(
                                <MenuItem key={`option-${index}`} value={things.value}>
                                    <Typography>{things.label}</Typography>
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={4}>
                    <TextField
                      type="number"
                      label="Presión en la llanta 3"
                      variant="filled"
                      fullWidth
                      InputProps={{ inputProps: { min: 1 } }}
                      value={report[KEYS_VALUES.presion_3]}
                      onChange={handlingValueTire("presion_3")}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField id={`${POSITION}-P4`} fullWidth disabled={isBus} onChange={handlingValueTire("P4")} select label="Pocision P4" variant="filled" defaultValue={handlingText(report[KEYS_VALUES.P4])} value={report[KEYS_VALUES.P4].id}>
                        {
                            marcaOptions.map((marca, index)=>(
                                <MenuItem key={`option-${index}`} value={marca.id}>
                                    <Typography>{marca.label}</Typography>
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={4}>
                    <TextField id={`${POSITION}-m4`} onChange={handlingValueTire("m4")} fullWidth select label="Milimetros P4" variant="filled" defaultValue={report[KEYS_VALUES.m4]} value={report[KEYS_VALUES.m4]} >
                        {
                            M_VALUES.map((things, index)=>(
                                <MenuItem key={`option-${index}`} value={things.value}>
                                    <Typography>{things.label}</Typography>
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={4}>
                    <TextField
                      type="number"
                      label="Presión en la llanta 4"
                      variant="filled"
                      fullWidth
                      InputProps={{ inputProps: { min: 1 } }}
                      value={report[KEYS_VALUES.presion_4]}
                      onChange={handlingValueTire("presion_4")}
                    />
                </Grid>

                {
                    isBus &&
                    <Fragment>

                        <Grid item xs={4}>
                            <TextField id={`${POSITION}-P5`} disabled fullWidth onChange={handlingValueTire("P5")} select label="Pocision P5" variant="filled" defaultValue={handlingText(report[KEYS_VALUES.P5])} value={report[KEYS_VALUES.P5].id}>
                                {
                                    marcaOptions.map((marca, index)=>(
                                        <MenuItem key={`option-${index}`} value={marca.id}>
                                            <Typography>{marca.label}</Typography>
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>

                        <Grid item xs={4}>
                            <TextField id={`${POSITION}-m5`} onChange={handlingValueTire("m5")} fullWidth select label="Milimetros P5" variant="filled" defaultValue={report[KEYS_VALUES.m5]} value={report[KEYS_VALUES.m5]} >
                                {
                                    M_VALUES.map((things, index)=>(
                                        <MenuItem key={`option-${index}`} value={things.value}>
                                            <Typography>{things.label}</Typography>
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                              type="number"
                              label="Presión en la llanta 1"
                              variant="filled"
                              fullWidth
                              InputProps={{ inputProps: { min: 1 } }}
                              value={report[KEYS_VALUES.presion_5]}
                              onChange={handlingValueTire("presion_5")}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField id={`${POSITION}-P6`} fullWidth onChange={handlingValueTire("P6")} select label="Pocision P6" variant="filled" defaultValue={handlingText(report[KEYS_VALUES.P6])} value={report[KEYS_VALUES.P6].id}>
                                {
                                    marcaOptions.map((marca, index)=>(
                                        <MenuItem key={`option-${index}`} value={marca.id}>
                                            <Typography>{marca.label}</Typography>
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>

                        <Grid item xs={4}>
                            <TextField id={`${POSITION}-m6`} onChange={handlingValueTire("m6")} fullWidth select label="Milimetros P6" variant="filled" defaultValue={report[KEYS_VALUES.m6]} value={report[KEYS_VALUES.m6]} >
                                {
                                    M_VALUES.map((things, index)=>(
                                        <MenuItem key={`option-${index}`} value={things.value}>
                                            <Typography>{things.label}</Typography>
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                              type="number"
                              label="Presión en la llanta 1"
                              variant="filled"
                              fullWidth
                              InputProps={{ inputProps: { min: 1 } }}
                              value={report[KEYS_VALUES.presion_6]}
                              onChange={handlingValueTire("presion_6")}
                            />
                        </Grid>

                    </Fragment>
                }


            </Grid>


        </Paper>
    );
}